import type { DepositType } from '@api';
import { DepositsTable } from '@features*';
import { Box } from '@mantine/core';

type FinanceDepositsPagePropsType = {
  deposits: DepositType[];
  isPending: boolean;
};

export const FinanceDepositsPage: React.FC<FinanceDepositsPagePropsType> = ({
  deposits,
  isPending,
}) => {
  return (
    <Box py="md">
      <DepositsTable deposits={deposits} isPending={isPending} />
    </Box>
  );
};
